import { Button, UptownLink } from "@/components";
import { PrismicRichText } from "@prismicio/react";
import Styles from "./Circle.module.css";
import Local from "./ShopifyProducts.module.css";

/**
 * Renders cards for products picked from the Shopify catalog via the Prismic
 * "Custom API" integration field. Each item's `shopify_product` holds the data
 * our /api/shopify-catalog endpoint supplied (title, image, canonical store URL),
 * so no linked-document hydration is needed — it arrives with the normal fetch.
 *
 * Header (heading/description) and CTA mirror Equipment.jsx and use the same
 * primary field names, so switching a slice between the Equipment and Shopify
 * Products variations preserves those values. Header is rendered unconditionally
 * so the server/client element tree matches (avoids a hydration mismatch).
 */
const ShopifyProducts = ({ primary, items }) => {
	return (
		<section className={Styles.wrapper}>
			<div className={Styles.container} data-contain="true">
				<div className={Local.headerContainer}>
					<PrismicRichText field={primary?.description} />
					<h2 className={Styles.heading}>{primary?.heading}</h2>
				</div>
				<div className={Styles.cardContainer}>
					{items?.map((item, index) => {
						const product = item?.shopify_product;
						// Prismic returns the item object; our data lives under `blob`.
						const data = product?.blob || product;
						if (!data?.url) return null;
						return (
							<UptownLink
								link={{ link_type: "Web", url: data.url }}
								className={Styles.card}
								key={index}
							>
								<div className={Styles.imageContainer}>
									{data.image_url && (
										// Shopify images are external URLs; a plain <img> avoids
										// next/image remote-domain config.
										// eslint-disable-next-line @next/next/no-img-element
										<img
											src={data.image_url}
											alt={data.image_alt || data.title || ""}
											className={Styles.image}
										/>
									)}
								</div>
								<h4 className={Styles.cardTitle}>{data.title}</h4>
							</UptownLink>
						);
					})}
				</div>
				<div className={Styles.ctaContainer}>
					{primary?.cta_link && primary?.cta_label && (
						<Button link={primary?.cta_link} label={primary?.cta_label} />
					)}
				</div>
			</div>
		</section>
	);
};

export default ShopifyProducts;
